define('lq/events/actions/windowsLoginCommand',[
    'jquery',
    'lq',
    'lq/events/actions/eventAction',
    'lq/runtimeLocation'
], function ($, lq, EventAction, runtimeLocation) {
    'use strict';

    function WindowsLoginCommand(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
        return this;
    }

    EventAction.extend(WindowsLoginCommand, EventAction);

    WindowsLoginCommand.typeName = 'WindowsLoginCommand';

    WindowsLoginCommand.prototype.getBatchType = function () {
        return EventAction.DO_NOT_BATCH;
    };

    var getParameterByName = function (parameterName) {
        parameterName = parameterName.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
        var regexS = "[\\?&]" + parameterName + "=([^&#]*)";
        var regex = new RegExp(regexS);
        var results = regex.exec(runtimeLocation.getSearch());
        if (results == null)
            return "";
        else
            return decodeURIComponent(results[1].replace(/\+/g, " "));
    };

    var loginCallback = function (self, result, returnUrl, continuation, showBody) {
        if (result.status === 'Success') {
            if (self.isUserLoggedInEventEnabled()) {
                self.refreshCsrfTokenForNewUser(function () {
                    self.triggerUserLoggedInEvents(continuation, returnUrl);
                });
            } else {
                if (returnUrl)
                    window.location = lq.safeRedirectUrl(returnUrl, lq.getTenantUrl(''));
                else
                    window.location = lq.getTenantUrl('');
            }
        }
        else {
            if (showBody) $('body').show();

            if (result.status === 'InvalidCredentials')
                self.handleError('invalidCredentials', 'Invalid credentials.', continuation);
            else if (result.status === 'UserLoginNotAllowed')
                self.handleError('userLoginNotAllowed', 'The user is not allowed to log in.', continuation, result.userId);
            else if (result.status === 'AccountLocked')
                self.handleError('accountLocked', 'Your account has been locked out because of too many invalid login attempts.', continuation);
            else
                alert('Unable to login.');
        }
        if (result.eventsToExecute) {
            _.each(result.eventsToExecute, function (eventName) {
                self.piping.eventing.publish(eventName, self.eventSource, null, continuation, null);
            });
        }
    }

    WindowsLoginCommand.prototype.execute = function (continuation) {
        var returnUrl = getParameterByName('ReturnUrl');

        //deliberately not calling continuation(), because it makes no sense to continue event execution after a login/redirect
        var self = this;
        this.piping.dispatcher.dispatch(
            'LicquidAction/StartWindowsLogin', {
                commandId: self.eventData.command,
                appId: getParameterByName('AppId')
            }, function () {
                self.piping.dispatcher.dispatch(
                    'LicquidAction/LoginFromWindowsLogin', {
                        actionId: self.piping.actionId,
                        commandId: self.eventData.command,
                        appId: getParameterByName('AppId')
                    }, function (result) {
                        loginCallback(self, result, returnUrl, continuation, false);
                    });
            },
            { global: false },
            function () {
                self.handleError('invalidCredentials', 'Log in failed.', continuation);
            },
            true);
    };

    WindowsLoginCommand.prototype.handleError = function (eventName, defaultMessage, continuation, eventArg) {
        if (this.eventIsEnabled(eventName)) {
            this.triggerEvent(eventName, continuation, eventArg);
        } else {
            alert(defaultMessage);
            continuation();
        }
    };

    return WindowsLoginCommand;
});
